module.exports = __webpack_public_path__ + "img/56.1d6b6882.jpg";